import React from 'react';
import { CircularProgress } from '@mui/material';
import { DisplaySlot } from './slotTypes';

interface SlotTimeListProps {
  loading: boolean;
  error: string;
  slots: DisplaySlot[];
  selectedIso: string;
  disabled?: boolean;
  onSelect: (slot: DisplaySlot) => void;
}

const SlotTimeList: React.FC<SlotTimeListProps> = ({
  loading,
  error,
  slots,
  selectedIso,
  disabled,
  onSelect,
}) => {
  if (loading) {
    return (
      <div className="center-box">
        <CircularProgress size={28} />
      </div>
    );
  }
  if (error) {
    return <div className="center-box error">{error}</div>;
  }
  if (!slots.length) {
    return <p className="empty-message">No available time slots</p>;
  }

  return (
    <div className="time-slots-grid">
      {slots.map((slot) => (
        <button
          key={slot.iso}
          type="button"
          className={`time-slot-button ${selectedIso === slot.iso ? 'selected' : ''}`}
          disabled={disabled}
          onClick={() => onSelect(slot)}
        >
          {slot.label}
        </button>
      ))}
    </div>
  );
};

export default SlotTimeList;
